import type { Recipe } from "@/types"
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function arrayRecipeDiff(a: Recipe[], b: Recipe[]) {
  if (!a) return b
  if (!b) return a

  const recipeSetA = new Set(a)
  const recipeSetB = new Set(b)

  return [...recipeSetA].filter(r => !recipeSetB.has(r))
}
